import React from 'react';
import { B } from '../constants';

export default function ConfirmModal({ 
  open, 
  title = 'Confirm Delete', 
  message = 'Are you sure you want to delete this?',
  confirmText = 'Delete', 
  cancelText = 'Cancel',
  onConfirm, 
  onCancel,
  danger = true,
  icon = '🗑️'
}) {
  if (!open) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1001
    }}>
      <div style={{
        background: 'white', borderRadius: 16, padding: 24, maxWidth: 360, width: '85%',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>{icon}</div>
          <h3 style={{ fontFamily: "'Playfair Display',serif", fontSize: 20, margin: '0 0 8px 0', color: B.night }}>
            {title}
          </h3>
          <p style={{ color: B.muted, fontSize: 14, margin: 0, lineHeight: 1.5 }}>
            {message}
          </p>
        </div>
        
        <div style={{ display: 'flex', gap: 12 }}>
          <button 
            onClick={onCancel}
            style={{
              flex: 1, padding: '12px 20px', borderRadius: 10, border: '1px solid #ddd',
              background: 'white', color: B.night, fontSize: 14, fontWeight: 600, cursor: 'pointer'
            }}
          >
            {cancelText}
          </button>
          <button 
            onClick={onConfirm}
            style={{
              flex: 1, padding: '12px 20px', borderRadius: 10, border: 'none',
              background: danger ? '#dc3545' : B.forest, color: 'white', fontSize: 14, fontWeight: 600, 
              cursor: 'pointer'
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}